"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Tigran.Niksalyan on 09/23/2019.
 */
exports.WorkflowDesignerPointsMatrix = [
    { x: 0.5, y: 0, angle: 0, vectorX: 0, vectorY: -1, dir: 0, cx: '50%', cy: '0' },
    { x: 0.75, y: 0, angle: 0, vectorX: 0, vectorY: -1, dir: 0, cx: '75%', cy: '0' },
    { x: 1, y: 0.5, horizontal: true, angle: 90, vectorX: 1, vectorY: 0, dir: 1, cx: '100%', cy: '50%' },
    { x: 0.75, y: 1, angle: 180, vectorX: 0, vectorY: 1, dir: 2, cx: '75%', cy: '100%' },
    { x: 0.5, y: 1, angle: 180, vectorX: 0, vectorY: 1, dir: 2, cx: '50%', cy: '100%' },
    { x: 0.25, y: 1, angle: 180, vectorX: 0, vectorY: 1, dir: 2, cx: '25%', cy: '100%' },
    { x: 0, y: 0.5, horizontal: true, angle: 270, vectorX: -1, vectorY: 0, dir: 3, cx: '0', cy: '50%' },
    { x: 0.25, y: 0, angle: 0, vectorX: 0, vectorY: -1, dir: 0, cx: '25%', cy: '0' }
];
;
//# sourceMappingURL=workflow-designer-point-matrix.model.js.map